import type {ReactNode} from "react";
import {Image} from "antd";

interface IconTextProps {
  image: string
  text: ReactNode;
}

export function IconText({image, text} : IconTextProps) {
      return (
          <div className={"flex gap-1 items-center"}>
            <Image preview={false}  width={20} height={20} src={image} className={"me-2"} />
            <div>{text}</div>
          </div>
      )
}